import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope } from "react-icons/fa";
import "../pages/userpages/usercss/footer.css";
import logonameImg from "../images/logo-name.png";
import facebookImg from "../images/facebook.png";
import instagramImg from "../images/instagram.png";
import twitterImg from "../images/twitter.png";

export default function AppFooter() {
    return (
        <footer className="footer">
            <div className="footer-top">
                {/* Contact Info */}
                <div className="footer-contact">
                    <h4>Contact Us</h4>
                    <div className="contact-row">
                        <span className="icon-circle"><FaMapMarkerAlt /></span>
                        <div className="contact-text">
                            <p>8/F GAM Building,</p>
                            <p>210 EDSA Ext.,</p>
                            <p>Pasay City, Metro Manila,</p>
                            <p>Philippines</p>
                        </div>
                    </div>

                    <div className="contact-row">
                        <span className="icon-circle"><FaPhoneAlt /></span>
                        <div className="contact-text">
                            +63-2-8551-CFSI(2374)
                        </div>
                    </div>

                    <div className="contact-row">
                        <span className="icon-circle"><FaEnvelope /></span>
                        <div className="contact-text">
                            headquarters@cfsi.ph
                        </div>
                    </div>
                </div>

                {/* Social Media */}
                <div className="footer-social">
                    <h4>Follow Us</h4>
                    <div className="social-icons">
                        <a href="#"><img src={facebookImg} alt="Facebook" /></a>
                        <a href="#"><img src={instagramImg} alt="Instagram" /></a>
                        <a href="#"><img src={twitterImg} alt="Twitter" /></a>
                    </div>
                </div>

                {/* Logo */}
                <div className="footer-logo">
                    <img src={logonameImg} alt="Auravit Logo" />
                </div>
            </div>

            {/* Bottom Bar */}
            <div className="footer-bottom">
                © COPYRIGHT 2026 CFSI &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp; WEBSITE BY THE INF236 &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp; ALL RIGHTS RESERVED
            </div>
        </footer>
    );
}
